/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import Header from '../Header';
import EventPlayer3 from '../EventPlayer3';
import StyleContainerVideo from './style';

class EventPlayerRoute extends Component {
  render() {
    return (
      <div
        className="pressResume_container"
        style={{ backgroundColor: '#FFF' }}
      >
        <Header />
        <StyleContainerVideo>
          <EventPlayer3 />
        </StyleContainerVideo>
      </div>
    );
  }
}

export default EventPlayerRoute;
